import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Row, Table } from "@themesberg/react-bootstrap";
import { useCookies } from "react-cookie";
import moment from "moment-timezone";
import { getLotto535Periods } from "../../../controller/api/gamePeriod";
import { calculatePage, convertToVietnamTime } from "../../../helper/helper";
import Pagination from "../../../components/Pagination";
import EditPeriodPopup from "../../../components/EditPeriodPopup";

export default function Lotto535Period() {
  const [cookies] = useCookies(["lottmekong"]);
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ list: [], total: 0, totalPage: 0 });
  const [editingPeriod, setEditingPeriod] = useState(null);

  const loadPeriods = useCallback(async () => {
    const response = await getLotto535Periods(cookies.lottmekong, page);
    setData({
      list: response.data || [],
      total: response.total || 0,
      totalPage: calculatePage(response.total || 0),
    });
  }, [cookies.lottmekong, page]);

  useEffect(() => {
    document.title = "Kỳ quay Lotto 5/35";
    loadPeriods();
  }, [loadPeriods]);

  return (
    <Card border="light" className="shadow-sm mt-4">
      <Card.Header>
        <h5 className="mb-1">Kỳ quay Lotto 5/35 ({data.total})</h5>
        <small className="text-muted">
          Chỉ theo dõi. Kỳ bán được sinh tự động theo cấu hình Lotto 5/35.
        </small>
      </Card.Header>
      <Table responsive className="align-items-center table-bordered table-hover mb-0">
        <thead className="text-center">
          <tr>
            <th>Mã kỳ</th>
            <th>Tên kỳ</th>
            <th>Ngày quay</th>
            <th>Giờ quay (VN)</th>
            <th>Số vé</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {data.list.map((period) => (
            <tr key={period.id}>
              <td>{period.id}</td>
              <td className="text-center">#{period.name}</td>
              <td className="text-center">{period.resultDate}</td>
              <td className="text-center">{convertToVietnamTime(period.dialDate)}</td>
              <td className="text-center">{period._count?.tickets || 0}</td>
              <td className="text-center">
                {moment(period.resultTime || period.dialDate).isAfter(moment()) && (
                  <Button variant="warning" size="sm" onClick={() => setEditingPeriod(period)}>
                    Sửa
                  </Button>
                )}
              </td>
            </tr>
          ))}
          {!data.list.length && (
            <tr><td colSpan="6" className="text-center text-muted">Không có kỳ đang chờ quay</td></tr>
          )}
        </tbody>
      </Table>
      <Card.Footer>
        <Row className="align-items-center">
          <Col>
            <Pagination totalPage={data.totalPage} currentPage={page} onPageChange={setPage} />
          </Col>
        </Row>
      </Card.Footer>
      <EditPeriodPopup
        show={!!editingPeriod}
        onHide={() => setEditingPeriod(null)}
        periodData={editingPeriod}
        gameType="Lotto 5/35"
      />
    </Card>
  );
}
